import {
    AlertColor,
    Box,
    Container,
    ContainerProps,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { Message, MessageRef } from "components/messages/message";
import { useTenantContext } from "contexts/tenantContext";
import React from "react";

//? ICONS & IMAGES //
import BackgroundLogo from "resources/politie.png";

//? STYLES //
import * as Styles from "styles/pages/content.styles";

//! ------------------------------------------------------------- //

//? MAIN COMPONENT //

const Content = (props: ContentProps) => {
    const { page, props: childProps } = props;
    const { currentTenant } = useTenantContext();
    const childRef = React.useRef<MessageRef>();
    const theme = useTheme();
    const isMobile = useMediaQuery(
        theme.breakpoints.down("sm") || theme.breakpoints.down("xs")
    );
    const isTablet = useMediaQuery(
        theme.breakpoints.down("lg") || theme.breakpoints.down("md")
    );

    const contentBox: ContentBox = {
        ...props,
        ...childProps,
        component: page,
        showMessage: (
            message: string,
            severity: AlertColor,
            autoHideDuration?: number | null
        ) => {
            childRef.current?.showMessage(message, severity, autoHideDuration);
        },
    };

    const backgroundImageBox: BackgroundImage = {
        component: "img",
        src: BackgroundLogo,
        alt: "background",
        sx: Styles.background,
    };

    const containerBox: ContainerProps = {
        maxWidth: "xl",
        sx: Styles.container,
    };

    return (
        <Box>
            <Container {...containerBox}>
                <Message ref={childRef} />
                <Box {...contentBox} />
            </Container>

            {/* //* Background image */}
            {!isMobile && !isTablet && (currentTenant === null || (currentTenant !== null && currentTenant.zoneNum === '5345')) ? <Box {...backgroundImageBox} /> : ''}
        </Box>
    );
};

export default Content;
